import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { StepInput } from './StepInput';
import { RiskBadge } from '../../RiskBadge';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import ButtonDefault from '@/components/ui/ButtonDefault';
import { RelatedReport } from '@/context/Resolution886Report/types';
import { useVibrationTools } from './_hooks/useVibrationTools';
import * as S from './styles';

interface VibrationToolsProps {
	name: string;
	categoryKey: string;
	relatedReport: RelatedReport | null;
}

export function VibrationTools(props: Readonly<VibrationToolsProps>): JSX.Element {
	const { toolMsg, isWholeBodyVibration, isDisabled, relatedReport, handleChange, handleOnClick } =
		useVibrationTools(props);

	return (
		<Col span={24} xl={12} style={{ padding: '0 20px 0 30px' }}>
			<S.CustomLabel>{toolMsg}</S.CustomLabel>
			<Row gutter={[32, 16]} align="middle">
				{isWholeBodyVibration && (
					<Col span={24}>
						<FormItem
							name={['jds_d86', 'additional_evaluation_option']}
							required={isWholeBodyVibration}
							requiredMessage={I18n.get('This field is required')}
							style={{ marginBottom: 0 }}
						>
							<Select
								style={{ width: '100%' }}
								placeholder={I18n.get('Movement type')}
								options={[
									{ label: I18n.get('Vertical movement'), value: 'vertical_movement' },
									{
										label: I18n.get('Lateral and longitudinal movement'),
										value: 'lateral_longitudinal_movement'
									}
								]}
								onChange={handleChange}
								disabled={isDisabled}
							/>
						</FormItem>
					</Col>
				)}
				<FormItem noStyle shouldUpdate={(prev, next) => prev.jds_d86?.value !== next.jds_d86?.value}>
					{({ getFieldValue, setFieldsValue }) => {
						const value = getFieldValue(['jds_d86', 'value']);

						const handleOnChange = (newValue: number) => {
							setFieldsValue({ jds_d86: { value: Number(newValue).toFixed(1) } });
							handleChange();
						};

						return (
							<>
								<Col span={24} xl={12}>
									<S.Container>
										<S.Label>0</S.Label>
										<S.CustomSlider
											min={0}
											max={5}
											step={0.1}
											value={value}
											onChange={handleOnChange}
											disabled={isDisabled}
										/>
										<S.Label>5 m/s²</S.Label>
									</S.Container>
								</Col>
								<Col span={12} xl={6}>
									<StepInput
										min={0}
										max={5}
										step={0.1}
										value={value}
										onChange={handleOnChange}
										disabled={isDisabled}
									/>
								</Col>
							</>
						);
					}}
				</FormItem>
				<Col span={12} xl={6}>
					{relatedReport?.result?.risk ? (
						<RiskBadge risk={relatedReport?.result?.risk as string} size="large" />
					) : (
						<RiskBadge text="-" size="large" />
					)}
				</Col>
			</Row>
			<Row>
				<ButtonDefault onClick={handleOnClick} type="link">
					{I18n.get(isDisabled ? 'Edit on JDS-D86' : 'Fill tool on JDS-D86')}
				</ButtonDefault>
			</Row>
		</Col>
	);
}
